import { postAsync } from "./_base";

const priceApiUrl = import.meta.env.VITE_APP_API_PRICE_URL

export const getPriceAsync = (body: any) => {
  return postAsync(priceApiUrl, undefined, body);
}